import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { Button, Grid, Typography } from "@mui/material";
import Columns from "./columnsDef";
import { BoxStyle, ButtonStyle, HeaderStyle } from "../../style";
import CustomPagination from "../../../../components/CustomPagination";
// import { CustomConfirmPopup } from '../../components/CustomPopups/ConfirmPopup/CustomConfirmPopup';
import "./technicalFiles.css";
import TechnicalTaskFilesForm from "./TechnicalTaskFilesForm";
import {
  deleteTechnicalTaskFiles,
  getTaskTechnicalFiles,
} from "../../../../store/actions/Task";
import { useLocation, useParams } from "react-router-dom";
import setLoader from "../../../../components/CustomLoader/loaderState";
import { CustomConfirmPopup } from "../../../../components/CustomPopups/ConfirmPopup/CustomConfirmPopup";
import CustomModal from "../../../../components/CustomModalPop";
import ViewForm from "../../../Register/viewPage";
import { ProfileType } from "../../../../utility/commonTypes";

const TechnicalFiles = () => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState<any>([]);
  const [currentPageNo, setCurrentpageNo] = useState<number>(0);
  const [totalPageCount, setTotalPageCount] = useState<any>(0);
  const [successPopup, setSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalPop, setOpenModalPop] = useState<any>(false);
  const [selectedRowId, setRowId] = useState("");
  const [deleteSuccessPopup, setDeleteSuccessPopup] = useState(false);
  const[openUserDetailsPopUp,setOpenUserDetailsPopUp]=useState(false)
  const[userId,setUserId]=useState("")
  const params: any = useParams();
  const stateData = params;
  const getProfileType = useSelector((store: any) => {
    return store.auth?.globalAuthData?.usertype;
  });
  const isEditable = useSelector((store: any) => {
    return store?.taskDetails?.taskEditable?.[stateData?.taskId];
  });

  const handleClickOpen = () => {
    setOpenModalPop(true);
    setRowId("");
  };
  const handleUserDetails=(event:any,id:any)=>{
    setOpenUserDetailsPopUp(true)
    setUserId(id)
  }
  const location: any = useLocation();
  const fetchTaskTechnicalFilesList = (
    pageNumber: number,
    buttonType?: string
  ) => {
    try {
      setLoading(true);
      dispatch(
        getTaskTechnicalFiles(
          {
            id: stateData?.taskId,
            task_technical: 1,
            size: 10,
            page: pageNumber,
          },
          (data: any) => {
            setTotalPageCount(data?.totalItems);
            if (data?.rowsReturned) {
              setRowData(data?.rowsReturned);
            } else {
              setRowData([]);
            }
          }
        )
      );
    } catch (e) {
      console.log(e, "error");
    } finally {
      if (buttonType === "NEXT_PAGE") {
        setCurrentpageNo(pageNumber);
      } else {
        setCurrentpageNo(0);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskTechnicalFilesList(0, "ON_LOAD");
  }, []);

  const [deletePopUp, setDeletePopUp] = useState(false);
  const deleteTaskFile = (event: any, id: any) => {
    setDeletePopUp(true);
  };
  const editTaskFile = (event: any, id: any) => {
    setOpenModalPop(true);
    //   setRowId(id)
  };
  const onPendingItemSuccess = () => {
    fetchTaskTechnicalFilesList(0, "ON_LOAD");
    setSuccessPopup(true);
    setTimeout(()=>{
      setSuccessPopup(false);

    },5000)
   
  };
  const deleteTechnicalTaskFile = (event: any, id: any) => {
    setDeletePopUp(true);
    setRowId(id);
  };

  const editTechnicalTaskFile = (event: any, id: any) => {
    setOpenModalPop(true);
    setRowId(id);
  };

  const onClickYes = (fileName: any, taskId: any) => {
    setDeletePopUp(false);
    setLoader(true);

    dispatch(
      deleteTechnicalTaskFiles({ file_name: fileName, id: taskId }, function (
        res: any
      ) {
        setLoader(false);
        setDeleteSuccessPopup(true);
        setTimeout(()=>{
          setDeleteSuccessPopup(false);
    
        },5000)
        fetchTaskTechnicalFilesList(0, "ON_LOAD");
      })
    );
  };
  const onClickNo = () => {
    setDeletePopUp(false);
  };

  const defaultColumns = useMemo(() => {
    return Columns(editTechnicalTaskFile, deleteTechnicalTaskFile,handleUserDetails);
  }, []);

  const handleClose = () => {
    setOpenModalPop(false);
  };

  return (
    <>
      <Grid container direction="row" justifyContent={"space-between"}>
        <Typography sx={{ ...HeaderStyle }} className="my-4 mx-4">
          Integration Technical Files
        </Typography>
        {((ProfileType?.USER === getProfileType || ProfileType?.CUSTOMER === getProfileType) && isEditable) || ProfileType?.ADMIN === getProfileType ?  

        <div className="my-4 mx-4">
          <Button
            variant="contained"
            onClick={handleClickOpen}
            size="medium"
            className="py-2"
            sx={ButtonStyle}
          >
            Upload
          </Button>
        </div>:null}
      </Grid>
      <Box sx={{ ...BoxStyle }}>
        <DataGrid
          autoHeight
          rows={rowData}
          rowCount={totalPageCount}
          page={currentPageNo}
          columns={defaultColumns}
          pageSize={10}
          disableSelectionOnClick
          disableColumnMenu
          pagination
          paginationMode="server"
          loading={loading}
          components={{
            Pagination: CustomPagination,
          }}
          onPageChange={(data) => {
            fetchTaskTechnicalFilesList(data, "NEXT_PAGE");
          }}
        />
      </Box>

      {openModalPop && (
        <TechnicalTaskFilesForm
          row={selectedRowId}
          onSuccess={onPendingItemSuccess}
          handleClose={handleClose}
          openModalPop={openModalPop}
          setOpenModalPop={setOpenModalPop}
        />
      )}
              {((ProfileType?.USER === getProfileType || ProfileType?.CUSTOMER === getProfileType) && isEditable) || ProfileType?.ADMIN === getProfileType ?  

      <CustomConfirmPopup
        open={deletePopUp}
        close={() => {
          setDeletePopUp(false);
        }}
        closeAndSubmit={() => {}}
        rowId={selectedRowId}
        onClickYes={onClickYes}
        onClickNo={onClickNo}
        taskId={stateData?.taskId}
        title={`Delete Technical Task Files`}
        btnText={`${"Yes"}`}
        btnText1={`${"No"}`}
        description={`Are you sure you want to delete the selected row`}
        //  successIcon={true}
      />:null}
      <CustomModal
        title="Technical Task Files"
        onOpen={successPopup}
        content={"Technical Task Files Created/Updated Successfully"}
        modalType={"success"}
        width={"sm"}
        OnClickCloseIcon={() => {
          setSuccessPopup(false);
        }}
      />
        <CustomModal
            title="Details"
            height="80%"
            width="md"
             onOpen={openUserDetailsPopUp}
            customWidth="750px"
            backgroundColor="#E1E1E1"
            content={<ViewForm userId={userId} setOpenUserDetailsPopUp={setOpenUserDetailsPopUp}/>}
            OnClickCloseIcon={() => {
              setOpenUserDetailsPopUp(false);
            }}
          />
      <CustomModal
        title="Technical Task Files"
        onOpen={deleteSuccessPopup}
        content={"Technical Task Files Deleted Successfully"}
        modalType={"success"}
        width={"sm"}
        OnClickCloseIcon={() => {
          setDeleteSuccessPopup(false);
        }}
      />
    </>
  );
};

export default TechnicalFiles;
